import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';

const FlippingCard = ({ project }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <div className="relative w-full h-80 perspective-1000">
      <div 
        className={`relative w-full h-full transition-transform duration-700 transform-style-preserve-3d cursor-pointer ${
          isFlipped ? 'rotate-y-180' : ''
        }`}
        onClick={() => setIsFlipped(!isFlipped)}
      >
        {/* Front of card */}
        <div className="absolute w-full h-full backface-hidden bg-white rounded-xl shadow-lg p-6 flex flex-col items-center justify-center text-center border border-gray-200 hover:shadow-xl transition-shadow">
          <div className="text-6xl mb-4">{project.image}</div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">{project.title}</h3>
          <p className="text-gray-600 text-sm">{project.description}</p>
          <div className="mt-4 text-xs text-blue-600 font-medium">Click to flip →</div>
        </div>

        {/* Back of card */}
        <div className="absolute w-full h-full backface-hidden bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl shadow-lg p-6 text-white rotate-y-180">
          <h3 className="text-xl font-bold mb-3">{project.title}</h3>
          <div className="mb-4">
            <h4 className="font-semibold mb-2">Tech Stack:</h4>
            <div className="flex flex-wrap gap-2">
              {project.tech.map((tech, index) => (
                <span key={index} className="bg-white bg-opacity-20 px-2 py-1 rounded-md text-xs">
                  {tech}
                </span>
              ))}
            </div>
          </div>
          <div className="mb-4">
            <h4 className="font-semibold mb-2">Challenge:</h4>
            <p className="text-sm opacity-90">{project.challenge}</p>
          </div>
          <a 
            href={project.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-blue-600 px-4 py-2 rounded-lg font-medium hover:bg-gray-100 transition-colors"
          >
            <ExternalLink size={16} />
            View Project
          </a>
        </div>
      </div>
    </div>
  );
};

export default FlippingCard;